<body>
  <div class="grid-overlay">
    <app-page-header></app-page-header>

    <div class="reports-data">
      <div class="page-heading">
        <div>
          <h1>{{ 'allowedOrigins.header.title' | translate }}</h1>
          <p>{{ 'allowedOrigins.header.subtitle' | translate }}</p>
        </div>
      </div>

      <div class="rbac-tabs">
        <button type="button" class="active">{{ 'allowedOrigins.tabs.origins' | translate }}</button>
      </div>

      <section>
        @if (mode === 'all') {
          <div class="hint">
            {{ 'allowedOrigins.mode.allActive' | translate }}
          </div>
        }

        <div class="table-toolbar">
          <div class="counters">
            @if (mode === 'restricted' && config) {
              <span>
                {{ 'allowedOrigins.counters.usage' | translate:{ used: config.total_used_origins, max: config.max_allowed_origins } }}
              </span>
            }
          </div>
          <div class="toolbar-actions">
            @if (mode === 'restricted') {
              <button mat-raised-button color="primary"
                [disabled]="!canAddMore" (click)="openCreateModal()">
                <mat-icon>add</mat-icon>
                {{ 'allowedOrigins.buttons.addOrigin' | translate }}
              </button>
            }
            @if (mode === 'restricted') {
              <button mat-raised-button type="button" (click)="switchToAll()">
                {{ 'allowedOrigins.buttons.switchToAll' | translate }}
              </button>
            }
            @if (mode === 'all') {
              <button mat-raised-button color="primary" type="button" (click)="switchToRestricted()">
                {{ 'allowedOrigins.buttons.switchToRestricted' | translate }}
              </button>
            }
          </div>
        </div>

        @if (mode === 'restricted') {
          <mat-table [dataSource]="dataSource" class="rbac-table">
            <ng-container matColumnDef="origin">
              <mat-header-cell *matHeaderCellDef>{{ 'allowedOrigins.table.origin' | translate }}</mat-header-cell>
              <mat-cell *matCellDef="let row" [attr.data-label]="'allowedOrigins.table.origin' | translate">{{ row.origin }}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="created_by">
              <mat-header-cell *matHeaderCellDef>{{ 'allowedOrigins.table.createdBy' | translate }}</mat-header-cell>
              <mat-cell *matCellDef="let row" [attr.data-label]="'allowedOrigins.table.createdBy' | translate">{{ row.created_by }}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="created_at">
              <mat-header-cell *matHeaderCellDef>{{ 'allowedOrigins.table.createdAt' | translate }}</mat-header-cell>
              <mat-cell *matCellDef="let row" [attr.data-label]="'allowedOrigins.table.createdAt' | translate">{{ row.created_at }}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="actions">
              <mat-header-cell *matHeaderCellDef>{{ 'allowedOrigins.table.actions' | translate }}</mat-header-cell>
              <mat-cell *matCellDef="let row" [attr.data-label]="'allowedOrigins.table.actions' | translate">
                <button mat-icon-button [matMenuTriggerFor]="originMenu" (click)="$event.stopPropagation()">
                  <mat-icon class="text-muted">more_vert</mat-icon>
                </button>
                <mat-menu #originMenu="matMenu">
                  <button mat-menu-item (click)="openEditModal(row)" class="menu_report">
                    <mat-icon>edit</mat-icon>
                    {{ 'allowedOrigins.actions.edit' | translate }}
                  </button>
                  <button mat-menu-item (click)="deleteOrigin(row)" class="menu_report">
                    <mat-icon>delete</mat-icon>
                    {{ 'allowedOrigins.actions.delete' | translate }}
                  </button>
                </mat-menu>
              </mat-cell>
            </ng-container>
            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
          </mat-table>
        }

        @if (mode === 'restricted' && dataSource.data.length === 0) {
          <div class="hint">
            {{ 'allowedOrigins.messages.noOrigins' | translate }}
          </div>
        }
      </section>
    </div>

    <div class="options-buttons">
      <button class="back-btn" (click)="goBack()">{{ 'allowedOrigins.buttons.back' | translate }}</button>
    </div>
  </div>

  <div class="modal-overlay" [class.show]="isOriginModalOpen">
    <div class="modal-content">
      <div class="modal-header">
        <h2>{{ (editingOrigin ? 'allowedOrigins.modal.editTitle' : 'allowedOrigins.modal.createTitle') | translate }}</h2>
        <button mat-icon-button type="button" (click)="closeModal()">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <form [formGroup]="originForm" (ngSubmit)="saveOrigin()">
        <mat-form-field appearance="fill" class="full-width">
          <mat-label>{{ 'allowedOrigins.modal.originLabel' | translate }}</mat-label>
          <input matInput formControlName="origin" placeholder="https://ejemplo.com" maxlength="499">
          @if (originForm.get('origin')?.hasError('required')) {
            <mat-error>
              {{ 'allowedOrigins.modal.originRequired' | translate }}
            </mat-error>
          }
          @if (originForm.get('origin')?.hasError('pattern')) {
            <mat-error>
              {{ 'allowedOrigins.modal.originInvalid' | translate }}
            </mat-error>
          }
        </mat-form-field>

        <div class="modal-actions">
          <button mat-raised-button type="button" (click)="closeModal()">{{ 'allowedOrigins.buttons.cancel' | translate }}</button>
          <button mat-raised-button color="primary" type="submit" [disabled]="originForm.invalid">
            {{ 'allowedOrigins.buttons.save' | translate }}
          </button>
        </div>
      </form>
    </div>
  </div>
</body>
